if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        if (!this.form) return;
        const variantInput = this.form?.querySelector('[name="id"]');
        if (variantInput && this.dataset.awaitingExplicitSize !== 'true') {
          variantInput.disabled = false;
        }
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        //this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.cart = document.querySelector('mini-cart');
        this.submitButton = this.querySelector('[type="submit"]');
        if (!this.submitButton) return;
        this.submitButtonText = this.submitButton.querySelector('span');
        this.explicitSizeErrorMessage =
          this.dataset.selectSizeErrorMessage || 'Please select a size';

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
        this.explicitSizeModeInitialized = false;
        this.explicitSizeUserInteracted = false;
        this.explicitSizeLastChangeAt = 0;
        this.setupExplicitSizeMode();
        this.setupExplicitSizeModeObserver();
        this.onExplicitSizeChangeBound = this.onExplicitSizeChange.bind(this);
        this.onExplicitSizeClickBound = this.onExplicitSizeClick.bind(this);
        this.addEventListener('change', this.onExplicitSizeChangeBound);
        document.addEventListener('click', this.onExplicitSizeClickBound, true);
        document.addEventListener('change', this.onExplicitSizeChangeBound);
        this.variantIdInput?.addEventListener('change', this.onExplicitSizeChangeBound);
      }

      disconnectedCallback() {
        if (this.onExplicitSizeChangeBound) {
          this.removeEventListener('change', this.onExplicitSizeChangeBound);
          document.removeEventListener('click', this.onExplicitSizeClickBound, true);
          document.removeEventListener('change', this.onExplicitSizeChangeBound);
          this.variantIdInput?.removeEventListener('change', this.onExplicitSizeChangeBound);
        }
        if (this.explicitSizeModeObserver) {
          this.explicitSizeModeObserver.disconnect();
          this.explicitSizeModeObserver = null;
        }
      }

      onExplicitSizeChange(event) {
        this.ensureExplicitSizeMode();
        if (!this.shouldForceExplicitSizeSelection()) return;
        const target = event?.target;
        const isVariantControl =
          target?.matches?.('variant-selects input[type="radio"], variant-selects select') ||
          target?.matches?.('input[type="radio"][form], select[form]') ||
          target === this.variantIdInput;
        if (!isVariantControl) return;

        const targetFormId = target?.getAttribute?.('form') || target?.form?.id;
        if (targetFormId && targetFormId !== this.form?.id) return;
        if (this.isSizeInput(target)) {
          this.explicitSizeUserInteracted = true;
          this.explicitSizeLastChangeAt = Date.now();
        }
        if (target === this.variantIdInput && (this.variantIdInput?.value || '').trim() !== '') {
          this.explicitSizeUserInteracted = true;
          this.explicitSizeLastChangeAt = Date.now();
        }        
        this.handleErrorMessage();
        this.syncExplicitSizeButtonState();
      }

      onExplicitSizeClick(event) {
        this.ensureExplicitSizeMode();
        if (!this.shouldForceExplicitSizeSelection()) return;
        const target = event?.target;
        let sizeInput = null;

        if (this.isSizeInput(target)) {
          sizeInput = target;
        } else {
          const label = target?.closest?.('[data-size-option="true"] label[for]');
          if (label) {
            sizeInput = document.getElementById(label.getAttribute('for'));
          }
        }

        if (!this.isSizeInput(sizeInput)) return;
        this.explicitSizeUserInteracted = true;
        setTimeout(() => {
          if (!sizeInput?.isConnected) return;
          const recentNativeChange = Date.now() - this.explicitSizeLastChangeAt < 90;
          const hasVariantId = (this.variantIdInput?.value || '').trim() !== '';
          if (!recentNativeChange && (!hasVariantId || !sizeInput.checked)) {
            sizeInput.checked = true;
            sizeInput.dispatchEvent(new Event('change', { bubbles: true }));
          }
          this.handleErrorMessage();
          this.syncExplicitSizeButtonState();
        }, 0);
      }

      shouldForceExplicitSizeSelection() {
        // Never apply the explicit-size test logic in quick add / quick view contexts.
        if (this.closest('quick-add-modal') || this.closest('.quick-view')) return false;
        if (this.dataset.awaitingExplicitSize === 'true') return true;
        if (window.__IG_EXPLICIT_SIZE__ === true) return true;
        if (document.body?.classList.contains('ig-explicit-size-test')) return true;
        if (document.documentElement?.classList.contains('ig-explicit-size-test')) return true;
        return false;
      }

      setupExplicitSizeMode() {
        if (!this.shouldForceExplicitSizeSelection()) return;
        this.explicitSizeModeInitialized = true;
        this.explicitSizeUserInteracted = false;

        const variantInput = this.variantIdInput;
        if (variantInput) {
          variantInput.value = '';
          variantInput.setAttribute('disabled', 'disabled');
        }

        this.clearSelectedSizeOption();
        this.syncExplicitSizeButtonState();
        // Some theme/app scripts can rehydrate selected variant right after init.
        setTimeout(() => {
          if (!this.shouldForceExplicitSizeSelection()) return;
          if (this.explicitSizeUserInteracted) {
            this.syncExplicitSizeButtonState();
            return;
          }
          const input = this.variantIdInput;
          if (input && !this.hasExplicitSizeSelected()) {
            input.value = '';
            input.setAttribute('disabled', 'disabled');
          }
          this.clearSelectedSizeOption();
          this.syncExplicitSizeButtonState();
        }, 120);
      }

      ensureExplicitSizeMode() {
        if (this.explicitSizeModeInitialized) return;
        if (!this.shouldForceExplicitSizeSelection()) return;
        this.setupExplicitSizeMode();
      }

      setupExplicitSizeModeObserver() {
        if (typeof MutationObserver === 'undefined') return;
        const watchTargets = [document.documentElement, document.body].filter(Boolean);
        if (!watchTargets.length) return;

        this.explicitSizeModeObserver = new MutationObserver((mutations) => {
          if (!mutations.some((mutation) => mutation.type === 'attributes' && mutation.attributeName === 'class')) {
            return;
          }
          this.ensureExplicitSizeMode();
        });

        watchTargets.forEach((target) => {
          this.explicitSizeModeObserver.observe(target, { attributes: true, attributeFilter: ['class'] });
        });
      }

      clearSelectedSizeOption() {
        this.getSizeOptionInputs().forEach((input) => {
          if (!input.checked) return;
          input.checked = false;
          input.removeAttribute('checked');
          input.dispatchEvent(new Event('change', { bubbles: true }));
        });
      }

      hasExplicitSizeSelected() {
        if (this.getSizeOptionInputs().some((input) => input.checked)) return true;
        // Keep button/error state in sync when theme updates only hidden variant id.
        if ((this.variantIdInput?.value || '').trim() !== '') return true;
        return false;
      }

      getSizeOptionInputs() {
        const formId = this.form?.id;
        if (!formId) return [];
        const strict = Array.from(
          document.querySelectorAll(`[data-size-option="true"] input[type="radio"][form="${formId}"]`)
        );
        if (strict.length) return strict;

        // Fallback for templates/apps that don't include data-size-option marker
        return Array.from(
          document.querySelectorAll(`variant-selects input[type="radio"][form="${formId}"]`)
        ).filter((input) => (input.name || '').toLowerCase().includes('size'));
      }

      isSizeInput(element) {
        if (!(element instanceof Element)) return false;
        if (!element.matches('input[type="radio"]')) return false;
        const targetFormId = element.getAttribute('form') || element.form?.id;
        if (targetFormId && targetFormId !== this.form?.id) return false;
        return this.getSizeOptionInputs().includes(element);
      }

      setExplicitSizeSelectedState(selected) {
        const selectedString = selected ? 'true' : 'false';
        this.dataset.igSizeSelected = selectedString;
        const stateRoot = this.closest('product-info') || this.closest('.product__info-container');
        if (stateRoot?.dataset) {
          stateRoot.dataset.igSizeSelected = selectedString;
        }
        const variantSelects =
          stateRoot?.querySelector?.('variant-selects[data-primary]') ||
          document.querySelector(`variant-selects[data-primary][data-section="${this.dataset.sectionId}"]`);
        if (variantSelects?.dataset) {
          variantSelects.dataset.igSizeSelected = selectedString;
        }
      }

      syncExplicitSizeButtonState() {
        document.querySelector(".product-form__input--wrapper")?.classList.remove("error")
        document.querySelector(".product-form__input--pill")?.classList.remove("error")
        if (!this.shouldForceExplicitSizeSelection()) return;

        if (this.hasExplicitSizeSelected()) {
          this.setExplicitSizeSelectedState(true);
          if (this.submitButton) {
            this.submitButton.removeAttribute('disabled');
          }
          if (this.submitButtonText) {
            const usePreOrder = this.submitButton.dataset.preOrder === 'true';
            this.submitButtonText.textContent = usePreOrder ? theme.variantStrings.preOrder : theme.variantStrings.addToCart;
          }
          return;
        }

        if (this.variantIdInput) {
          this.variantIdInput.value = '';
          this.variantIdInput.setAttribute('disabled', 'disabled');
        }
        this.setExplicitSizeSelectedState(false);
        if (this.submitButton) {
          this.submitButton.removeAttribute('disabled');
          this.submitButton.removeAttribute('aria-disabled');
        }
        // if (this.submitButtonText) {
        //   this.submitButtonText.textContent = this.dataset.selectSizeLabel || 'SELECT A SIZE';
        // }
      }

      showExplicitSizeError() {
        // this.handleErrorMessage(this.explicitSizeErrorMessage);
        document.querySelector(".product-form__input--wrapper")?.classList.add("error")
        document.querySelector(".product-form__input--pill")?.classList.add("error")
        this.submitButton.classList.remove('ig-size-shake');
        // Force reflow to allow repeated shake on subsequent clicks
        void this.submitButton.offsetWidth;
        this.submitButton.classList.add('ig-size-shake');
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        this.ensureExplicitSizeMode();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        if (this.shouldForceExplicitSizeSelection() && !this.hasExplicitSizeSelected()) {
          this.showExplicitSizeError();
          return;
        }
        if (!this.blockSubmitIfRequiredFieldsEmpty(evt)) return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        //this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${theme.routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = theme.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            //this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      blockSubmitIfRequiredFieldsEmpty(event) {
        if (!(this.form instanceof HTMLFormElement)) {
          throw new Error("Expected a form element.");
        }

        const formId = this.form.getAttribute('id');
        const requiredFields = document.querySelectorAll('[required]');
        let allFilled = true;
        for (const field of requiredFields) {
          const belongsToForm = (field.getAttribute('form') === formId || field.closest('form')?.id === formId);
          if (!belongsToForm) continue;
          
          let isValid = true;
          switch (field.type) {
            case 'checkbox':
            case 'radio':
              const group = document.querySelectorAll(`input[name="${field.name}"][type="${field.type}"]`);
              const isChecked = Array.from(group).some(input => input.checked);
              isValid = isChecked;
              break;
            case 'select-one':
              isValid = field.value !== '';
              break;
            case 'textarea':
            case 'text':
            case 'email':
            case 'number':
            case 'url':
            default:
              isValid = field.value.trim() !== '';
              break;
          }
          if (!isValid) {
            allFilled = false;
            field.classList.add('invalid');
          } else {
            field.classList.remove('invalid');
          }
        }
    
        if (!allFilled) {
          event.preventDefault();
          this.handleErrorMessage(theme.accessibilityStrings.fillInAllLineItemPropertyRequiredFields);
          return false;
        }
        return true;
      }
      
      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text !== undefined && text !== false && text !== '') {
            this.submitButtonText.textContent = text;
          }
        } else {
          this.submitButton.removeAttribute('disabled');
          const usePreOrder = this.submitButton.dataset.preOrder === 'true';
          this.submitButtonText.textContent = usePreOrder ? theme.variantStrings.preOrder : theme.variantStrings.addToCart;
        }

        this.syncExplicitSizeButtonState();
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
